import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddEditCoScholasticTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [classList, setClassList] = useState([]);
    const [className, setClassName] = useState([]);
    const [coScholasticList, setCoScholasticList] = useState([]);
    const [coScholasticName, setCoScholasticName] = useState([]);
    const [coScholasticType, setCoScholasticType] = useState('Activity');

    const submitButtonRef = useRef(null);
    const titleNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetCoScholasticList(loginData?._id, props?.masterData?.Type ?? coScholasticType);
        if (props?.configId) {
            setTitleName(props?.masterData?.TemplateName);
            setClassName(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
            setCoScholasticType(props?.masterData?.Type);
            setCoScholasticName(props?.masterData?.CoScholasticName ? props?.masterData?.CoScholasticName.split(',') : []);
        }
    }, []);


    const GetCoScholasticList = async (id, type) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCoScholasticList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCoScholasticList(res?.data?.filter(y => y?.Type === type && y?.Status === 'Active')?.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.CoScholasticName} (${x?.Type})`
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props?.configId,
                    TemplateName: titleName.trim().replace(/\s+/g, ' '),
                    CoScholasticName: coScholasticName ? coScholasticName.join(',') : '',
                    Type: coScholasticType,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateCoScholasticTemplate, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
            }
        }
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className='p-grid p-px-1'>
                    <div className="p-col-12 p-md-12 p-pt-2">
                        <label htmlFor="titleName">Template Name</label>
                        <div className="custom-inputs">
                            <FloatLabel>
                                <InputText
                                    ref={titleNameRef}
                                    className='p-w-100 p-mt-1'
                                    id="titleName"
                                    value={titleName}
                                    onChange={(e) => setTitleName(e.target.value)}
                                    style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }}
                                />
                            </FloatLabel>
                        </div>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {titleNameErr ? titleNameErrText : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <RadioButton
                                inputId="Activity"
                                name="coScholasticType"
                                value="Activity"
                                checked={coScholasticType === 'Activity'}
                                onChange={(e) => {
                                    setCoScholasticType(e.value);
                                    GetCoScholasticList(securityUserID, e.value);
                                }}
                            />
                            <label htmlFor="Activity"> Activity</label>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <RadioButton
                                inputId="Elements"
                                name="coScholasticType"
                                value="Elements"
                                checked={coScholasticType === 'Elements'}
                                onChange={(e) => {
                                    setCoScholasticType(e.value);
                                    GetCoScholasticList(securityUserID, e.value);
                                }}
                            />
                            <label htmlFor="Elements"> Elements</label>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-12 p-pt-2">
                        <div className="e-add-fee-structure">
                            <label htmlFor="coScholasticName">Co-Scholastic</label>
                            <div className="custom-inputs">
                                <MultiSelect
                                    id="coScholasticName"
                                    value={coScholasticName}
                                    options={coScholasticList}
                                    onChange={(e) => setCoScholasticName(e.value)}
                                    placeholder="Select Co-Scholastic"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter
                                    onKeyDown={(e) => {
                                        if (e.key === 'Tab' && !e.shiftKey) {
                                            e.preventDefault();
                                            if (submitButtonRef.current) {
                                                submitButtonRef.current.focus();
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
        </div >
    );
};

export default AddEditCoScholasticTemplate;
